import React from 'react';
import { Alert } from 'react-bootstrap';
import { FaExclamationTriangle } from 'react-icons/fa';
import './StoreClosedBanner.css';

const StoreClosedBanner = ({ message }) => {
  return (
    <Alert variant="warning" className="store-closed-banner mb-0">
      <div className="d-flex align-items-center justify-content-center">
        <FaExclamationTriangle className="me-2" size={24} />
        <strong className="me-2">Store Temporarily Closed:</strong>
        <span>{message || 'Our store is currently closed. Browsing is available, but orders cannot be placed at this time.'}</span>
      </div>
    </Alert>
  );
};

export default StoreClosedBanner;
